module.exports = __webpack_public_path__ + "img/10blue.874b146f.png";